import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#0B0B0D] flex flex-col">
      <SEO
        title="Privacy Policy | Subsurface"
        description="How Subsurface handles personal data, diagnostic responses and operator communications."
        path="/privacy"
      />
      <Navigation />

      <div className="flex-1 pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold font-display mb-8">Privacy Policy</h1>
          
          <div className="glass-card p-8 rounded-lg space-y-6 text-[#A0A0A0]">
            <p className="text-sm">Last updated: January 2026</p>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">1. Information We Collect</h2>
              <p className="leading-relaxed">We collect information you provide directly when using Subsurface services, including name, company, email, and diagnostic responses.</p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">2. How We Use Your Information</h2>
              <p className="leading-relaxed mb-2">We use collected information to:</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Provide trust and risk intelligence services</li>
                <li>Generate diagnostic reports</li>
                <li>Communicate about your submission</li>
                <li>Improve our platform</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">3. Data Storage</h2>
              <p className="leading-relaxed">Your data is stored securely and used solely for service delivery and platform improvement.</p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">4. Contact</h2>
              <p className="leading-relaxed">For privacy inquiries: <a href="mailto:hello@subsurfaceconsulting.co" className="text-[#FF6A00] hover:text-[#FF6A00]/80">hello@subsurfaceconsulting.co</a></p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
